import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from './ui/button';
import { Zap, X } from 'lucide-react';

export const UpgradeModal = ({ isOpen, onClose, subscription }) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" data-testid="upgrade-modal">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />

      {/* Modal */}
      <div className="relative bg-card border border-border rounded-2xl p-6 sm:p-8 max-w-md w-full shadow-2xl">
        <button
          onClick={onClose}
          className="absolute top-4 right-4 text-muted-foreground hover:text-foreground"
          data-testid="upgrade-modal-close"
        >
          <X className="h-5 w-5" />
        </button>

        <div className="text-center">
          <div className="w-14 h-14 bg-teal-700/15 rounded-full flex items-center justify-center mx-auto mb-4">
            <Zap className="h-7 w-7 text-teal-400" />
          </div>

          <h2 className="text-xl font-bold text-foreground mb-2">
            You've used all your generations
          </h2>
          <p className="text-sm text-muted-foreground mb-6">
            You've used{' '}
            <span className="font-medium text-foreground">
              {subscription?.generations_used || 0} of {subscription?.monthly_generations || 2}
            </span>{' '}
            free generations this month. Upgrade to keep building.
          </p>

          <div className="space-y-3 mb-6">
            <div className="flex items-center justify-between p-3 bg-secondary/70 rounded-xl">
              <div className="text-left">
                <p className="font-medium text-foreground text-sm">Basic</p>
                <p className="text-xs text-muted-foreground">10 generations/mo</p>
              </div>
              <span className="font-bold text-foreground">$27/mo</span>
            </div>
            <div className="flex items-center justify-between p-3 bg-teal-700/10 border border-teal-500/30 rounded-xl">
              <div className="text-left">
                <p className="font-medium text-foreground text-sm">Pro</p>
                <p className="text-xs text-muted-foreground">Unlimited generations</p>
              </div>
              <span className="font-bold text-teal-400">$97/mo</span>
            </div>
          </div>

          <Button
            onClick={() => { onClose(); navigate('/pricing'); }}
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
            data-testid="upgrade-modal-cta"
          >
            <Zap className="mr-2 h-4 w-4" />
            View Plans
          </Button>

          <button
            onClick={onClose}
            className="mt-3 text-xs text-muted-foreground hover:text-foreground"
          >
            Maybe later
          </button>
        </div>
      </div>
    </div>
  );
};
